import React from 'react'
import Reservation from './Reservation'


function App(props) {
    return(
        <Reservation {...props} />
    )
}


export default App

